import React, { FC } from 'react';
import { Alert, Snackbar, SnackbarCloseReason } from '@mui/material';
import { colors } from '../../colors/Colors';
import { NotificationType } from '../../model/Types';

interface ToastMessageProps {
    toastOpen: boolean;
    message: string;
    onToastClose: (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => void;
    type: NotificationType;
}

export const ToastMessage: FC<ToastMessageProps> = ({ toastOpen, message, onToastClose, type }) => {
    const getAlertColor = (type: NotificationType) => {
        switch (type) {
            case NotificationType.SUCCESS:
                return { width: '100%', color: colors.background, backgroundColor: colors.primary };
            case NotificationType.INFO:
                return { width: '100%', color: colors.background, backgroundColor: colors.accent };
            case NotificationType.ERROR:
            case NotificationType.WARNING:
                return { width: '100%', color: colors.background, backgroundColor: colors.error };
            default:
                return { width: '100%', color: colors.background, backgroundColor: colors.primary };
        }
    };

    return (
        <Snackbar open={toastOpen} autoHideDuration={4000} onClose={onToastClose}>
            <Alert
                variant="filled"
                sx={getAlertColor(type)}
                onClose={onToastClose}
                severity={type.toLowerCase() as 'success' | 'info' | 'warning' | 'error'}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
